import moment from 'moment'
import generatePickerTimesForDay from '@ancon/wildcat-utils/outlet/generatePickerTimesForDay'
import { PickerTime } from '@ancon/wildcat-utils/outlet/types'

import { CapacityConflictPickupTimeRange } from '../types'

/**
 * Same step every other time picker in the app uses. The payload carries no slot
 * length, so this is the fallback until it does.
 */
const SlotIntervalMinutes = 10

/**
 * Selectable pickup times inside the ranges the API returned.
 *
 * `generatePickerTimesForDay` stops one interval before the end, so a slot always
 * fits inside its range, and it de-duplicates against the times already collected -
 * which is what keeps overlapping ranges from producing the same time twice.
 *
 * TODO: Filter out times that fall outside the outlet's opening hours, as the API
 * currently does not exclude the outlet closing hours from the returned ranges.
 */
export default function getCapacityConflictAvailableTimes(
  ranges: CapacityConflictPickupTimeRange[],
): string[] {
  const now = moment().valueOf()

  const times = ranges.reduce<PickerTime[]>(
    (collected, range) =>
      collected.concat(
        generatePickerTimesForDay(
          moment(range.start),
          moment(range.end),
          collected,
          SlotIntervalMinutes * 60 * 1000,
        ),
      ),
    [],
  )

  // A range can start before now, and a time that has already passed can't be booked.
  return times
    .filter(time => time.timestamp > now)
    .sort((first, second) => first.timestamp - second.timestamp)
    .map(time => moment(time.timestamp).toISOString())
}
